import React, { use,useEffect } from 'react'; 
import { FiUploadCloud, FiUpload } from 'react-icons/fi';
import profiler from '../../../assets/RecruiterLogo.png'; // Assuming you have this logo
import { useNavigate } from 'react-router-dom';
import { resumeUpload } from "../../../supports/resumeUpload";
import { generateRequestId } from '../../../common/common';
import unifiedAuthManager from '../../../services/unifiedAuthManager';

const ResumeUpload = () => {
  const [error, setError] = React.useState('');
  const [selectedFile, setSelectedFile] = React.useState(null);
  const fileInputRef = React.useRef(null);
  const navigate = useNavigate();
  const candidate = unifiedAuthManager.getUnifiedUser()
  const isAuthed = unifiedAuthManager.isAuthenticated();
  const userRoles = unifiedAuthManager.getUserRoles();
    const isCandidate = userRoles.some(role => 
    role.toLowerCase().includes('role_candidateuser')
  );


  // Allowed file types and max size (2MB)
  const allowedTypes = [
    'application/pdf',
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  ];
  const maxSize = 5 * 1024 * 1024; // 5MB

  // Helper to check extension for drag-and-drop (since .doc/.docx may have empty type in some browsers)
  const isAllowedExtension = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    return ['pdf', 'doc', 'docx'].includes(ext);
  };

  const handleFileChange = (e) => {
    setError('');
    const file = e.target.files[0];
    if (!file) return;

    if (e.target.files.length > 1) {
      setError('Please upload only one file at a time.');
      setSelectedFile(null);
      return;
    }

    // Validate file type or extension
    if (
      !allowedTypes.includes(file.type) &&
      !isAllowedExtension(file.name)
    ) {
      setError('Only PDF, DOC, and DOCX files are allowed.');
      setSelectedFile(null);
      return;
    }

    // Validate file size
    if (file.size > maxSize) {
      setError('File size must be less than 2MB.');
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
    uploadFile(file)
  };

  const uploadFile = async (file) => {
   const response = await resumeUpload.uploadResume({
  files: [file],

  ...(isAuthed && isCandidate && !candidate.resume_id && {
    signup_flag: true,
    user_id: candidate.id,
    user_email: candidate.email,
  }),

  user_payload: {
    request_id: generateRequestId(),
  },
})
    console.log(response)
    if (response.status == 'Success') {
      if(isAuthed){
       navigate(`/job-recommendations?resumeId=${response.data.doc_id[0]}`);
      }
      else{
       navigate(`/Resume-profile?resumeId=${response.data.doc_id[0]}`);
      }
 
    } else {
      setError(response.message);
      setSelectedFile(null);
    }
  }

  const handleUploadClick = () => {
    setError('');
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Reset file input so same file can be selected again
      fileInputRef.current.click();
    }
  };

  // Only allow single file on drag and drop
  const handleDrop = (e) => {
    e.preventDefault();
    setError('');
    const files = e.dataTransfer.files;
    if (!files || files.length === 0) return;

    if (files.length > 1) {
      setError('Please upload only one file at a time.');
      setSelectedFile(null);
      return;
    }

    const file = files[0];

    // Validate file type or extension
    if (
      !allowedTypes.includes(file.type) &&
      !isAllowedExtension(file.name)
    ) {
      setError('Only PDF, DOC, and DOCX files are allowed.');
      setSelectedFile(null);
      return;
    }

    // Validate file size
    if (file.size > maxSize) {
      setError('File size must be less than 2MB.');
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
    uploadFile(file)
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };


   const handleSignout = () => {
    unifiedAuthManager.clearAll?.();
    navigate('/resume-login');
  };

  return (
    <div className="">
      <div className="w-full flex flex-col gap-2 max-w-md text-center">
        <img src={profiler} alt="MPH Logo" className="w-24 mx-auto mb-4" />
        <h2 className="text-md font-bold text-gray-333">Get Discovered by Top Employers</h2>

        <div
          className="mt-8 border-2 border-dashed border-gray-999 rounded-xl p-8 w-full"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <FiUploadCloud className="mx-auto h-12 w-12 profiler" />
          <p className="mt-8 text-xs text-gray-666">Drag and drop your CV into the zone</p>

          <div className="flex items-center justify-center my-2">
            <div className="w-24 border-t border-gray-300"></div>
            <span className="flex-shrink-0 mx-6 text-gray-666 text-xs">Or</span>
            <div className="w-24 border-t border-gray-300"></div>
          </div>

          <input
            type="file"
            accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
            multiple={false}
          />
          <button
            className="profiler-bg text-xs font-semibold px-3 py-1.5 rounded-full flex items-center justify-center gap-2 mx-auto"
            type="button"
            onClick={handleUploadClick}
          >
            Upload resume <FiUpload size={16} />
          </button>
          <div className="mt-3 text-xs text-gray-666 text-center">
            Supported files: <span className="font-bold text-gray-333">PDF, DOCX</span> &middot; Max size: <span className="font-bold text-gray-333">2MB</span>
          </div>
          {selectedFile && (
            <div className="mt-2 text-xs text-emerald-600 text-center">
              Selected: <span className="font-bold">{selectedFile.name}</span>
            </div>
          )}
          <p className="mt-1 text-[10px] text-blue-500">
            ⚠️ Please ensure that a valid email ID is present in the resume. Once uploaded, you cannot change the email ID.
          </p>
          {error && (
            <div className="mt-2 text-xs text-red-500 text-center">
              {error}
            </div>
          )}
        </div>

        <p className="text-xs text-left bg-gray-100 p-1 px-2 rounded text-gray-999 mt-4">
          By uploading your resume, you agree to let us securely store your data and contact you with personalized job offers.
        </p>
<div className="flex text-gray-999 py-3 mt-2 border-t text-xs font-semibold">
  {isAuthed ? "Having trouble in uploading your resume?" : "Already have an account?"}

  <div
    onClick={()=>handleSignout()}
    className="text-[#B2853D] cursor-pointer flex ml-1 hover:underline transition-all duration-200"
  >
    Login
  </div>
</div>
        </div>
    </div>
  );
};

export default ResumeUpload;